var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg18New(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8163 33.5144V19.9399H12.6782V16.4612H20.1464V33.5144H15.8163Z",
    fill: "#E8910C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4205 20.8641C36.4205 22.348 35.6177 23.6616 34.2797 24.3915C36.1527 25.1699 37.3205 26.7999 37.3205 28.6973C37.3205 31.7624 34.5958 33.7086 30.3387 33.7086C26.0815 33.7086 23.357 31.7866 23.357 28.7704C23.357 26.8241 24.622 25.1699 26.5923 24.3915C25.1571 23.5886 24.2327 22.2265 24.2327 20.7426C24.2327 18.0178 26.6168 16.2908 30.3145 16.2908C34.0607 16.2908 36.4205 18.0666 36.4205 20.8641ZM27.4438 28.3325C27.4438 29.7679 28.4656 30.5706 30.3387 30.5706C32.2118 30.5706 33.2578 29.7924 33.2578 28.3325C33.2578 26.9218 32.2118 26.1188 30.3387 26.1188C28.4655 26.1188 27.4438 26.9216 27.4438 28.3325ZM27.8818 21.1074C27.8818 22.324 28.7576 23.0048 30.3387 23.0048C31.92 23.0048 32.7957 22.3238 32.7957 21.1074C32.7957 19.8428 31.92 19.1371 30.3387 19.1371C28.7573 19.1371 27.8818 19.8428 27.8818 21.1074Z",
    fill: "#E8910C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5265 18.3864C45.2464 20.511 45.6115 22.7334 45.6115 25C45.6115 36.3651 36.3651 45.6115 24.9999 45.6115C13.6345 45.6115 4.38799 36.3651 4.38799 25C4.38799 13.6345 13.6344 4.38844 24.9997 4.38844C27.2666 4.38844 29.4889 4.75334 31.6134 5.47354V0.886689C29.4675 0.298451 27.2512 0 24.9999 0C11.215 0 0 11.215 0 25C0 38.785 11.215 50 24.9999 50C38.7847 50 49.9995 38.785 49.9995 25C49.9995 22.7488 49.7012 20.5324 49.113 18.3864H44.5265Z",
    fill: "#E8910C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.279 6.70622V1.9126H39.832V6.70622H35.0671V10.1529H39.832V14.9464H43.279V10.1529H48.0723V6.70622H43.279Z",
    fill: "#E8910C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg18New);
export default __webpack_public_path__ + "static/media/18-new.e01ce5b78ee9d9831b3c79464ea2fa67.svg";
export { ForwardRef as ReactComponent };